module.exports = __webpack_public_path__ + "static/wilmaa_web_tv_1-451ffe7e6e9923d0995cbaa261caaf98.jpg";